import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Box,
  CircularProgress,
  Stack,
  Tab,
  Tabs,
  Alert,
  Button,
} from "@mui/material";
import { languageOptions } from "../../../languages";
import "./StaticContentManagement.scss";
import staticContentStore from "../../../stores/StaticContentStore";
import { useParams } from "react-router-dom";

const StaticContentManagement = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("tr");
  const [editorValue, setEditorValue] = useState("");
  const [content, setContent] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { key } = useParams<{ key: string }>();
  const hasChanges = content !== editorValue;

  useEffect(() => {
    if (key) {
      setLoading(true);
      staticContentStore
        .fetchStaticContent(key, selectedLanguage)
        .then((data) => {
          setEditorValue(data?.content || "");
          setContent(data?.content || null);
        })
        .finally(() =>
          setTimeout(() => {
            setLoading(false);
          }, 300)
        );
    }
  }, [selectedLanguage]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedLanguage(newValue);
  };

  const handleEditorChange = (value: string) => {
    setEditorValue(value);
  };

  const handleSubmit = () => {
    if (!content || !key) {
      return;
    }
    setLoading(true);
    staticContentStore
      .updateStaticContent(key, selectedLanguage, editorValue)
      .finally(() => {
        setContent(editorValue);
        setLoading(false);
      });
  };

  return (
    <div className="container admin-container dictionary-management">
      {loading ? (
        <Stack
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          className={"pt pb"}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedLanguage}
              onChange={handleTabChange}
              aria-label="language tabs"
            >
              {languageOptions.map((lang) => (
                <Tab key={lang.key} label={lang.key} value={lang.key} />
              ))}
            </Tabs>
          </Box>
          <Box sx={{ mt: 2 }}>
            <ReactQuill
              theme="snow"
              value={editorValue}
              onChange={handleEditorChange}
              style={{ height: "400px", marginBottom: "16px" }}
              modules={{
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ["bold", "italic", "underline", "strike"],
                  ["blockquote", "code-block"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link"],
                  ["clean"],
                ],
              }}
            />
            <footer>
              <Button
                fullWidth
                variant="outlined"
                disabled={!editorValue || !hasChanges || loading}
                onClick={handleSubmit}
              >
                Kaydet
              </Button>
            </footer>
          </Box>
        </>
      )}
    </div>
  );
};

export default StaticContentManagement;
